/** css */
import './UncheckComponent.css';
import UncheckComponent from './UncheckComponent';

export default UncheckComponent;
